/**
 * Pushes page_view events into dataLayer on route change.
 * Google Tag Manager can map these events to GA4 or other tags.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

export function GoogleAnalytics(): null {
  const location = useLocation();

  useEffect(() => {
    if (!Array.isArray(window.dataLayer)) return;
    window.dataLayer.push({
      event: 'page_view',
      page_path: location.pathname + location.search,
      page_title: document.title,
      page_location: window.location.href,
    });
  }, [location.pathname, location.search]);

  return null;
}
